import Web3 from "web3";
import contractAbiMoeda from "./abi_moeda.json";

export const Mint = async (address_to, amount, serialNumber, value) => {
  let signer;
  let signature;
  let hashedMessage;

  try {
    console.log('3', signer, '\n', signature, '\n', hashedMessage);

    console.log('2', '\n', 'endereço:', address_to, '\n', 'qtd:', amount, '\n', 'numero:', serialNumber, '\n', 'valor:', value);


    if (!window.ethereum) {
      throw new Error("No crypto wallet found. Please install it.");
    }

    // Criação da instância Web3 e solicitação de conta da MetaMask
    const web3 = new Web3(window.ethereum);
    await window.ethereum.request({ method: "eth_requestAccounts" });
    const accounts = await web3.eth.getAccounts();

    console.log('contas:', accounts);

    signer = accounts[0];

    // Gera o hash da mensagem com o serialNumber
    hashedMessage = web3.utils.soliditySha3({
      type: "string",
      value: serialNumber,
    });
    console.log("Mensagem hash gerada:", hashedMessage);

    // Assina a mensagem com o MetaMask
    signature = await window.ethereum.request({
      method: "personal_sign",
      params: [hashedMessage, signer],
    });
    console.log("Mensagem assinada:", signature);

    // Criando a instância do contrato
    const contract = new web3.eth.Contract(
      contractAbiMoeda,
      "0x0d8cc4b8d15d4c3ef1d70af0071376fb26b5669b" // Endereço do contrato
    );

    // Verifica os parâmetros antes de enviar a transação
    console.log("Parâmetros enviados para a transação:", {
      address_to,
      amount,
      serialNumber,
      value,
      signature,
    });

    // Define o limite de gas e o preço do gas
    // Enviar a transação
    const gasLimit = 6721975; // Ajuste o limite de gas conforme necessário
    const gasPrice = await web3.eth.getGasPrice();

    const mintTransaction = contract.methods
      .mint(address_to, amount, serialNumber, value, signature)
      .send({ from: signer, gas: gasLimit, gasPrice: gasPrice }); // o signer aqui é quem está conectado à Metamask, e necessariamente precisa ser o dono do contrato, quem o compilou no remix IDE

    // Agora, usando o `Promise` corretamente com `resolve` e `reject`
    const receipt = await new Promise((resolve, reject) => {
      mintTransaction
        .on("receipt", resolve) // A transação foi bem-sucedida
        .on("error", reject); // Erro na transação
    });

    // Verifique se a transação foi revertida
    if (receipt.status === 0) {
      throw new Error("Transação revertida! Verifique as regras do contrato.");
    }

    console.log("Transação confirmada!", receipt);
    return receipt;

    // Retorna a confirmação e informações extras
    return {
      transaction: mintTransaction,
      contratoAddress: mintTransaction.events.Transfer?.address || null, // Evita erro caso Transfer não exista
      signer: signer,
      signature: signature,
      hashedMessage: hashedMessage,
    };
  } catch (err) {
    // Captura e exibe o erro de forma detalhada
    const error = {
      mensagem: err.message,
      signer: signer,
      signature: signature,
      hashedMessage: hashedMessage,
    };

    console.error("Erro na transação:", error);
    throw error; // Repassa o erro para a camada superior
  }
};
